import { ActivityIcon, DropdownIcon } from "app/components/Icons";
import CustomTooltip from "app/components/Tooltip";
import clsx from "clsx";
import React from "react";

interface Props {
  isAllSelected: boolean;
  selectedItems: string[];
  selectedItemNames: string[];
  title?: string;
  icon?: React.ReactNode;
}

const DropdownButton: React.FC<Props> = ({
  isAllSelected,
  selectedItems,
  selectedItemNames,
  title,
  icon,
}) => {
  const displayText = `${title} ${
    isAllSelected
      ? "All"
      : selectedItemNames.length
      ? selectedItemNames.join(", ")
      : " "
  }`;

  const iconColor =
    isAllSelected || selectedItems.length ? "#5A8DF1" : "#79808A";

  const textColorClass =
    isAllSelected || selectedItems.length ? "text-primary" : "text-secondary";

  const clonedIcon =
    icon &&
    React.cloneElement(icon as React.ReactElement, {
      color: isAllSelected || selectedItems.length ? "#5A8DF1" : "#79808A",
    });

  return (
    <CustomTooltip
      position="bottom"
      className="flex flex-row items-center justify-between text-wrap w-full "
      contentClassName="break-words max-w-60 text-wrap max-w-[200px]"
      text={displayText}
    >
      <div className=" flex flex-row w-full items-center justify-between gap-1 truncate ">
        <div className="flex flex-row items-center justify-start gap-1 truncate">
          {icon ? clonedIcon : <ActivityIcon size={20} color={iconColor} />}
          <span
            className={clsx(
              "text-sm font-medium mt-[2px] max-w-[300px] truncate",
              textColorClass
            )}
          >
            {displayText}
          </span>
        </div>
        <div className=" min-w-5 w-5">
          <DropdownIcon size={20} color={iconColor} />
        </div>
      </div>
    </CustomTooltip>
  );
};

export default DropdownButton;
